export default "__VITE_ASSET__CWIykQx3__"